export interface SilenceMonitorOptions {
  analyser: AnalyserNode;
  thresholdMs: number;
  onChange: (isSilentSince: number | null) => void;
  frameSampleModulo?: number; // sample every N frames; default 12
  onSample?: (sample: { peak: number; rms: number; timestamp: number }) => void;
}

export function startSilenceMonitor(opts: SilenceMonitorOptions) {
  const { analyser, thresholdMs: _thresholdMs, onChange, frameSampleModulo = 12, onSample } = opts;
  let rafId = 0;
  let audioIsSilentSince: number | null = null;
  let frameCounter = 0;

  const tick = () => {
    rafId = requestAnimationFrame(tick);

    frameCounter++;
    if (frameCounter % frameSampleModulo !== 0) return;

    const timeDomainData = new Uint8Array(analyser.fftSize);
    analyser.getByteTimeDomainData(timeDomainData);

    let isSilent = true;
    let peak = 0;
    let sumSquares = 0;
    for (let i = 0; i < timeDomainData.length; i++) {
      const value = timeDomainData[i];
      const normalized = (value - 128) / 128;
      const abs = Math.abs(normalized);
      peak = Math.max(peak, abs);
      sumSquares += normalized * normalized;
      if (isSilent && (value > 128 || value < 127)) {
        isSilent = false;
      }
    }

    const rms = Math.sqrt(sumSquares / timeDomainData.length);
    const timestamp = Date.now();
    onSample?.({ peak, rms, timestamp });

    const next = isSilent ? (audioIsSilentSince ?? Date.now()) : null;
    if (next !== audioIsSilentSince) {
      audioIsSilentSince = next;
      onChange(audioIsSilentSince);
    }
  };

  rafId = requestAnimationFrame(tick);
  return () => cancelAnimationFrame(rafId);
}
